import { kyc as base } from './base';
import { kyc as AT } from './AT';
import { kyc as CZ } from './CZ';
import { kyc as RO } from './RO';
import { kyc as HR } from './HR';

export const featureConfigMap = {
    base,
    AT,
    CZ,
    RO,
    HR,
};
